// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_6b-6";
export var headerCell = "_6b-2";
export var loadingStateContent = "_6b-8";
export var rowWrapper = "_6b-4";
export var stickyAggregationCell = "_6b-b";
export var stickyAggregationRow = "_6b-7";
export var stickyColumnCell = "_6b-a";
export var stickyColumnHeaderCell = "_6b-9";
export var table = "_6b-1";
export var virtualRowWrapper = "_6b-5";
export var virtualTableContainer = "_6b-0";
export var white = "_6b-3";